export default "__VITE_ASSET__6D5GzBFO__"